import React from 'react';

//Componentes material mui
import { Typography } from '@mui/material';

//Estilos
import { ComponenteExtra1024Style } from './ComponenteExtra1024Style';

export default function ComponenteExtra1024({ Logo = '', Texto = '' }) {
    return (
        <div style={{ width: '100%' }}>
            <div style={ComponenteExtra1024Style.DivStyle}>
                {Logo === null ? null : <img src={Logo} alt="BannerIcon" style={ComponenteExtra1024Style.ImgStyle} />}
                <div style={ComponenteExtra1024Style.DivTextStyle}>
                    <Typography variant='body1' style={ComponenteExtra1024Style.DescriptionTextStyle}>
                        {Texto}
                    </Typography>
                </div>
            </div>
        </div>
    );
}